export default __webpack_public_path__ + "static/media/delete.c62ca343.svg";